/** Segmento proporcional da barra de composição. */
export interface CompositionSegment {
  readonly key: string;
  /** Classe Tailwind de cor de fundo, vinda dos tokens (ex.: `bg-base-accent-500`). */
  readonly colorClass: string;
  /** Largura do segmento em pontos percentuais (0–100). */
  readonly percent: number;
}

export interface CompositionBarProps {
  readonly segments: readonly CompositionSegment[];
  /** Descrição textual da composição, para leitores de tela. */
  readonly ariaLabel: string;
}

/**
 * Barra horizontal de segmentos proporcionais.
 *
 * Segue o mesmo padrão do `SegmentBar`: a largura é orientada a dado, então usa `style`
 * apenas para a dimensão dinâmica (percentual não é expressável como classe estática do
 * Tailwind) — todas as cores vêm de classes de token.
 */
export function CompositionBar({ segments, ariaLabel }: CompositionBarProps) {
  return (
    <div
      className="flex h-nano w-full overflow-hidden rounded-pill bg-ctx-layout-body"
      role="img"
      aria-label={ariaLabel}
    >
      {segments.map(segment => (
        <div
          key={segment.key}
          className={segment.colorClass}
          style={{ width: `${Math.max(0, Math.min(100, segment.percent))}%` }}
        />
      ))}
    </div>
  );
}
